var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f0f0f0"
    },
    points: "341.334 85.33 170.666 85.33 0 85.33 0 426.662 170.666 426.662 341.334 426.662 512 426.662 512 85.33"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6da544"
    },
    width: 170.663,
    height: 341.337,
    y: 85.333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 170.663,
    height: 341.337,
    x: 341.337,
    y: 85.333
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIta);
export default __webpack_public_path__ + "static/media/ita.cf467e80dbed933ddb556e67486d7162.svg";
export { ForwardRef as ReactComponent };